import React, { useLayoutEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { images, useCreditCardValidator } from "react-creditcard-validator";
import { toast } from "react-toastify";
import { Col, FormGroup, Button, Row } from "reactstrap";
import { LoadingSpinner } from "../../../../../components/Common/LoadingSpinner/LoadingSpinner";
import lock from "../../../../../assets/images/lock.svg";
import onvo from "../../../../../assets/images/logo/onvo.png";
import visa from "../../../../../assets/images/logo/visa_mastercard.png";
import { CouponRespository } from "../../../../../repositories/coupon";
import { useIsDesktop } from "../../../../../helpers/useIsDesktop";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { useHistory } from "react-router-dom";
import dropDown from '../../../..//../assets/images/drop-down.svg';
import "./index.css"
const full = 1;


export const CardForm = ({ handlerManagePayment, pricing, basePrice }) => {

    const {
        handleSubmit,
        formState: { errors }
    } = useForm();

    const expDateValidate = (year) => {
        if (Number(year) > 40) {
            return "Fecha de expiración no puede ser mayor a 2040";
        }
        return;
    };

    const {
        getCardNumberProps,
        getCardImageProps,
        getCVCProps,
        getExpiryDateProps,
        meta: { erroredInputs }
    } = useCreditCardValidator({ expiryDateValidator: expDateValidate });

    const [dataError, setDataError] = useState(false);
    const couponRef = useRef(null);
    const cardNumberProps = getCardNumberProps();
    const cardNameRef = useRef(null);
    const cardExpiryDateProps = getExpiryDateProps({ placeholder: "MM/YY" });
    const cardCvcProps = getCVCProps({ placeholder: "CVV" });

    const [loading, setLoading] = useState(false);
    const [validateCoupon, setValidateCoupon] = useState(false);
    const [couponLoading, setCouponLoading] = useState(false);
    const [couponMessage, setCouponMessage] = useState(null);
    const [couponType, setCouponType] = useState(null);
    const [open, setOpen] = useState(true)
    const history = useHistory();

    const getPaymentMethodInfo = () => {
        setDataError(false);
        const cardNumber = cardNumberProps.ref.current.value;
        const cardName = cardNameRef.current.value;
        const cardExpiryDate = cardExpiryDateProps.ref.current.value;
        const cvv = cardCvcProps.ref.current.value;

        const isCardNumberValid = cardNumber.trim() !== "" && !erroredInputs.cardNumber;
        const isCardNameValid = cardName.trim() !== "";
        const isExpiryDateValid = cardExpiryDate.trim() !== "" && !erroredInputs.expiryDate;
        const isCvcValid = cvv.trim() !== "" && !erroredInputs.cvc;

        const isFormValid = isCardNumberValid && isCardNameValid && isExpiryDateValid && isCvcValid;

        if (isFormValid) {
            const [month, year] = cardExpiryDate.split(" / ");
            const fullYear = "20" + year;
            return {
                type: "card",
                paymentMethod: {
                    number: cardNumber.replace(/ /g, ""),
                    expMonth: parseInt(month),
                    expYear: parseInt(fullYear),
                    cvv: cvv,
                    holderName: cardName
                }
            };
        } else {
            setDataError(true);
        }
    };

    const handlerPayment = async (e) => {
        const payload = getPaymentMethodInfo();
        if (payload) {
            await handlerManagePayment(payload);
        }
    };

    const onSave = async (data) => {
        setLoading(true);
        if (validateCoupon) {
            const repository = new CouponRespository();
            let response;
            if (validateCoupon.coupon_type === full) {
                response = await repository.aplicateCoupon(couponRef.current.value, {
                    type: "card",
                    paymentMethod: {
                        number: "",
                        expMonth: 0,
                        expYear: 0,
                        cvv: "",
                        holderName: ""
                    }
                });
            } else {
                const paymentMethod = getPaymentMethodInfo();
                if (paymentMethod) {
                    response = await repository.aplicateCoupon(
                        couponRef.current.value,
                        paymentMethod
                    );
                }
            }

            if (response) {
                if (response.status === 201) {
                    history.push("/how-it-works");
                } else {
                    toast.info(response.response.data.message);
                }
            }
        } else {
            await handlerPayment(data);
        }
        setLoading(false);
    };

    const applyCupon = async () => {
        if (!couponRef.current.value) {
            return;
        }
        const repository = new CouponRespository();

        try {
            setCouponLoading(true);
            const response = await repository.validate(couponRef.current.value);
            if (response.data.coupon_type) {
                setCouponType(response.data.coupon_type);
            }
            if (response.data.coupon_type === 1) {
                setCouponMessage("*Membresía gratis de por vida");
                setDataError(false);
            } else if (response.data.coupon_type === 2) {
                setCouponMessage("*Mismo precio de por vida");
            } else if (response.data.coupon_type === 3) {
                setCouponMessage("*Mismo precio de por vida");
            } else if (response.data.coupon_type === 4) {
                setCouponMessage("*Mismo precio de por vida");
            } else if (response.response.status in [404, 400]) {
                setCouponMessage(response.response.data.message);
                setValidateCoupon(false);
            }
            setValidateCoupon(response?.data);
        } catch (e) {
            setCouponMessage("El cupón ingresado no es válido.");
            setValidateCoupon(false);
            console.error(e);
        } finally {
            setCouponLoading(false);
        }
    };

    useLayoutEffect(() => {
        if (cardExpiryDateProps.ref.current) {
            cardExpiryDateProps.ref.current.style.borderRadius = "0.25rem";
        }
        if (cardCvcProps.ref.current) {
            cardCvcProps.ref.current.style.borderRadius = "0.25rem";
        }
    });

    const isDesktop = useIsDesktop();

    return (
        <form onSubmit={handleSubmit(onSave)}>
            <Row>
                <div className="pay-card-form">
                    <div className="card-form-fields">
                        <Col className="card-name-field">
                            <FormGroup className="input-group">
                                <div className="position-relative w-100">
                                    <svg
                                        {...getCardImageProps({ images })}
                                        className="me-3 position-absolute"
                                    />
                                    <label
                                        className={`poppins-family ${isDesktop ? "fw-bold" : ""
                                            }`}
                                    >
                                        Número de tarjeta
                                    </label>
                                    <input
                                        {...cardNumberProps}
                                        className="form-control w-100 payment-method-input ps-5"
                                        required
                                        style={{ color: "#ECA109", fontWeight: "bold" }}
                                    />
                                </div>
                                <small className="poppins-family ps-3">
                                    {erroredInputs.cardNumber && erroredInputs.cardNumber}
                                </small>
                            </FormGroup>
                        </Col>
                        <Col className="card-experitation-field">
                            <FormGroup>
                                <div className="input-group flex-column">
                                    <label
                                        className={`poppins-family ${isDesktop ? "fw-bold" : ""
                                            }`}
                                    >
                                        Expiración
                                    </label>
                                    <input
                                        {...cardExpiryDateProps}
                                        className="form-control w-100 payment-method-input ps-4 fw-bold"
                                        maxLength={7}
                                        minLength={7}
                                    />
                                    <small className="poppins-family ps-2">
                                        {erroredInputs.expiryDate && erroredInputs.expiryDate}
                                    </small>
                                </div>
                            </FormGroup>
                        </Col>
                        <Col className="card-ccv-field">
                            <FormGroup>
                                <div className="input-group flex-column">
                                    <label
                                        className={`poppins-family ${isDesktop ? "fw-bold" : ""
                                            }`}
                                    >
                                        CVV
                                    </label>
                                    <input
                                        {...cardCvcProps}
                                        className="form-control w-100 payment-method-input ps-5 fw-bold"
                                        required
                                        style={{ borderRadius: "0.25rem !important" }}
                                    />
                                    <small className="poppins-family ps-2">
                                        {erroredInputs.cvc && erroredInputs.cvc}
                                    </small>
                                </div>
                            </FormGroup>
                        </Col>
                        <Col className="card-full-name-field">
                            <FormGroup>
                                <label
                                    htmlFor="cardnameInput"
                                    className={`poppins-family ${isDesktop ? "fw-bold" : ""}`}
                                >
                                    Nombre del Titular de la Tarjeta
                                </label>
                                <input
                                    type="text"
                                    className="form-control w-100 payment-method-input ps-5 fw-bold"
                                    placeholder="Nombre de la tarjeta"
                                    ref={cardNameRef}
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </div>
                    <div className="security-logos">
                        <Col
                            lg="4"
                            xs={6}
                            className={`d-flex align-items-center ${isDesktop
                                ? "justify-content-start"
                                : "justify-content-center"
                                }`}
                        >
                            <div
                                className={`plan-securely-ssl-wrapper`}
                            >
                                <figure className="lock-content">
                                    <img src={lock} alt="" className="lock-item"/>
                                </figure>
                                <h4 className="plan-securely">Secured with SSL</h4>
                            </div>
                        </Col>
                        <Col xs={6}>
                            <div className="card-logos">
                                        <img src={onvo} alt="" />
                                        <img src={visa} alt="" />
                            </div>
                        </Col>
                    </div>
                    <hr />
                    <Row
                        className={`bg-white p-4 ${isDesktop ? "mt-4" : ""}`}
                        style={isDesktop ? { borderRadius: "2.5rem" } : {}}
                    >
                        <Col lg="12" xs={12}>
                            <div className="input-group flex-column">
                                <Row>
                                    <Col className="coupon-header">
                                        <label className="poppins-family fw-bold">
                                            Tengo un código de promoción
                                        </label>
                                        
                                        <button
                                            type="button"
                                            onClick={ () => setOpen(!open)}
                                            className="dropdown-btn"
                                        >
                                            {
                                                open ?
                                                <img src={dropDown} alt="dropdown icon" />
                                                :
                                                <img src={dropDown} alt="dropdown icon" className={`${!open && "dropdown-close" }`}/>

                                            }
                                        </button>
                                    </Col>
                                </Row>
                                <div
                                    className={`coupon-controls-control ${isDesktop ? "" : "d-flex align-items-center"} ${ open ? "show-coupon" : "hide-coupon"}`}
                                >

                                        <input
                                            className={`coupon-input form-control payment-method-input fw-bold ${isDesktop ? "ps-5" : "ps-3"
                                                }`}
                                            placeholder="Escribe tu código aquí"
                                            ref={couponRef}
                                            style={{ borderRadius: "0.25rem !important" }}
                                        />


                                        <Button
                                            className="cupon-code-btn"
                                            size="lg"
                                            onClick={applyCupon}
                                            disabled={false}
                                        >
                                            {couponLoading ? <LoadingSpinner /> : "Aplicar"}
                                        </Button>

                                </div>
                                <Row>
                                    <Col sm={12} className="mt-2">
                                        {!!couponMessage && (
                                            <span
                                                className="span-free-membership fw-bold"
                                                style={validateCoupon ? {} : { color: "#FF8264" }}
                                            >
                                                {couponMessage}
                                            </span>
                                        )}
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Row>
                            <Col xs={8} lg={5} className="mt-3">
                                <div className="d-flex flex-column">
                                    <label className="label-price-details fw-bold">
                                        Subtotal
                                    </label>
                                    <label className="label-price-details fw-bold mt-3">
                                        Total
                                    </label>
                                </div>
                            </Col>
                            <Col xs={4} lg={7} className="mt-3">
                                <div className="d-flex flex-column">
                                    <label className="label-price-details fw-bold">
                                        {`$${couponType
                                            ? couponType === 1
                                                ? "0.00"
                                                : couponType === 2
                                                    ? "9.99"
                                                    : couponType === 3
                                                        ? "54.00"
                                                        : "96.00"
                                            : basePrice
                                            }`}
                                    </label>
                                    <label className="label-price-details fw-bold mt-3">
                                        {`$${couponType
                                            ? couponType === 1
                                                ? "0.00"
                                                : couponType === 2
                                                    ? "9.99"
                                                    : couponType === 3
                                                        ? "54.00"
                                                        : "96.00  "
                                            : basePrice
                                            }`}
                                    </label>
                                </div>
                            </Col>
                        </Row>
                        <Col sm="12" className="mt-4">
                            <Row>
                                <Col sm={12} md={12} lg={12}>
                                    <Button
                                        className="payment-form-btn w-100"
                                        size="lg"
                                        onClick={onSave}
                                    >
                                        {loading && <LoadingSpinner />}
                                        Iniciar Prueba Gratis{" "}
                                        <i className="fas fa-arrow-right" />
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12} md={12} lg={12}>
                                    <small
                                        className="text-danger mt-1"
                                        style={{ fontSize: "16px" }}
                                    >
                                        {dataError && "*Verifique los datos del formulario"}
                                    </small>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Row>
        </form>

    )
}
